import { AxiosInstance } from "axios";
import { getContentType, getFileName, toastError, triggerDownload } from "helpers";
import { TranslationLabels } from "translations/TranslationLabels";

export class DownloadApi {
  constructor(
    private axios: AxiosInstance,
    private i18n: TranslationLabels
  ) {}

  async handleDownload(url: string, fileName?: string): Promise<void> {
    try {
      const response = await this.axios.get(url, {
        responseType: "blob",
        withCredentials: true,
      });

      const responseFileName = getFileName(response, fileName);
      const responseContentType = getContentType(response);
      triggerDownload(response.data, responseFileName, responseContentType);
    } catch (error) {
      toastError(this.i18n.ErrorCodes_InternalServerError, error);
    }
  }
}
